import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import MainTable from "../../components/tables/MainTable";
import endpoints from "../../services/endpoints";
import { TableDetailsItem } from "../../components/tables/tableFunctions";
import useApi from "../../services/useApi";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";
import { showToast } from "../../components/toastMessage/toastSlice";
import useTranslation from "../../components/CustomHooks/useTranslation";
// import { adminContents } from "./components/AdminManagementContent";
import { useCallback, useEffect, useState } from "react";
import { adminContents } from "../AdminManagement/components/AdminManagementContent";
import usePrivilege from "../../components/CustomHooks/usePrivilege";
import { setPreviousUrl } from "../../store/slices/geolocationSlice";

export default function ListofCompanies() {
  const navigation = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { companyList } = endpoints;
  const { translate } = useTranslation(adminContents);
  const { PatchAPI } = useApi();
  const [fetchListTrigger,setFetchListTrigger] = useState(false);
  const [searchPlaceholder, setSearchPlaceholder] = useState<string>('company name');
  const [isTransitioning, setIsTransitioning] = useState<boolean>(false);
  const hasAddPrivilege = usePrivilege("CMGT4")
  const hasEditPrivilege = usePrivilege("CMGT3")
  const hasViewPrivilege = usePrivilege("CMGT2")
  const TableDetails: { [key: string]: TableDetailsItem } = {
    "Company id": {
      id: "company_code",
      className: "min-w-[110px]",
    },
    "Company Name": {
      sort: true,
      id: "name",
      custom: ["company_name"],
      className: "min-w-[220px]",
    },
    "Company Location": {
      id: "user_location",
      custom: ["country", "province", "region"],
    },
    "Onboarded Date": {
      sort: true,
      id: "created_date",
      custom: ["created_at"],
      className: "min-w-[200px]",
    },
    "Contact Person": {
      id: "contact_person_name",
      // custom: ["created_at"],
    },
    "Representative Profession": {
      id: "representative_profession",
      // custom:['country_code', 'phone_number']
    },
    "Contact Email Address": {
      id: "contact_email",
    },
    "Contact Phone Number": {
      id: "contact_phone_number",
      custom:['country_code', 'contact_phone_number']
    },
    "Buisness Type": {
      id: "business_type",
      // custom: ["last_logged_in"],
    },
    Actions: {
      id: "actions",
      className: "min-w-[200px]", // Adding className here
      actionTypes: ["edit", "view"],
    },
  };
  const handleActions = async (id: string, key: string, text?: string) => {
    if (key === "view") {
      dispatch(setPreviousUrl(location.pathname + location.search))
      navigation(`/company-management/view-company/${id}`);
    } else if (key === "edit") {
      dispatch(setPreviousUrl(location.pathname + location.search))
      navigation(`/company-management/edit-company/${id}`);
    }
    else{
      return;
    }
  };
  const addButtonClick = () => {
    navigation("/company-management/add-company");
  };
  const staticText = {
    emptyScreenText: {
      heading1: translate("There are no companies added yet"),
      heading2: translate("Click “Add Company” to create one"),
    },
  };

  const SEARCH_PLACEHOLDERS = [
      'company name',
      'contact phone number',
      'company id'
    ] as const;
  
    const rotatePlaceholder = useCallback(() => {
      setIsTransitioning(true);
  
      setTimeout(() => {
        setSearchPlaceholder(prev => {
          const currentIndex = SEARCH_PLACEHOLDERS.indexOf(prev as typeof SEARCH_PLACEHOLDERS[number]);
          const nextIndex = (currentIndex + 1) % SEARCH_PLACEHOLDERS.length; // Loop cyclically
          return SEARCH_PLACEHOLDERS[nextIndex];
        });
        setIsTransitioning(false);
      }, 500);
    }, []);

    useEffect(() => {
        const interval = setInterval(rotatePlaceholder, 2500);
        return () => clearInterval(interval);
      }, [rotatePlaceholder]);
  return (
    <div>
      <Breadcrumbs
        navPath={["Company Management", "List of Companies"]}
        heading="List of Companies"
        noNavigation
        links={["/company-management"]}
        button={{
          buttonName: "Add Company",
          className: "w-[150px]",
          buttonOnclick: addButtonClick, // Corrected function type
        }}
        hasAddPrivilege={hasAddPrivilege}
        list={true}
      />
      <MainTable
        staticText={staticText}
        mainEndPoint={companyList}
        TableDetails={TableDetails}
        handleActions={handleActions}
        params={{ page_number: "1" , sort: "created_date+desc"}}
        searchPlaceholder={`Search by ${searchPlaceholder}`}
        placeholderClassName={`search-placeholder ${isTransitioning ? 'transitioning' : ''}`}
        filters={true}
        exporting={true}
        notfoundRoute={{ state: { route: '/company-management' } }}
        hasListPrivilege={true}
        hasViewMDPrivilege={hasViewPrivilege}
        hasEditMDPrivilege={hasEditPrivilege}
        fetchListTrigger={fetchListTrigger}
        statusNotFilter={true}
      />
    </div>
  );
}
